import { render, staticRenderFns } from "./CertifiedCarrier.vue?vue&type=template&id=280424b0"
import script from "./CertifiedCarrier.vue?vue&type=script&lang=js"
export * from "./CertifiedCarrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports